/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceCorpactionsV1ActionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_CORPACTIONS_V1_ACTION_STATE_ENTITY_NAME = 'exc.ice.corpactions.v1.Action';
export const excIceCorpactionsV1ActionStateEntity = new schema.Entity<ExcIceCorpactionsV1ActionState>(EXC_ICE_CORPACTIONS_V1_ACTION_STATE_ENTITY_NAME, {}, { idAttribute: 'eventId' });

